import { render, staticRenderFns } from "./AgingReportList.vue?vue&type=template&id=096ec483&"
import script from "./AgingReportList.vue?vue&type=script&lang=js&"
export * from "./AgingReportList.vue?vue&type=script&lang=js&"
import style0 from "./AgingReportList.vue?vue&type=style&index=0&id=096ec483&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports